import * as bootstrap from "bootstrap";

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// THEME MODULES
import { bootstrapTweaks } from "./modules/bootstrap-tweaks.js";
import DataAttrTransformer from "./modules/data-attr-transformer";
import Carousels from "./modules/carousels.js";
import setupAnimationUtilities from "./modules/animation-utilities.js";
import { local } from "./modules/local-storage";
import { utils } from "./modules/utils.js";

// Register Boostrap
window.bootstrap = bootstrap;

// Add GSAP to window and Register plugins
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollSmoother = ScrollSmoother;
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const { select, selectAll } = utils;

// --- BEGIN CUSTOM JAVASCRIPT --- //

// UTILITY FOR TRANSFORMING CLASSES TO ATTRIBUTES - disable if not using
DataAttrTransformer();

// TRANSPORT MODALS TO BODY AND HANDLE SCROLL PAUSING
bootstrapTweaks.handleModals(true);

// FLOATING LABELS FOR FORMS - disable if not using
bootstrapTweaks.addFloatingLabelsToForms(jQuery);

// INITIALIZE ANY SPLIDE CAROUSELS
Carousels();

// Only proceed with ScrollSmoother initialization if it's not a touch device
if (!utils.isTouchDevice()) {
  gsap.registerPlugin(ScrollSmoother);

  var smoother = ScrollSmoother.create({
    wrapper: ".pd_ss_wrapper",
    content: ".pd_ss_inner",
    smooth: 1,
    effects: false,
    smoothTouch: 0.1,
    ignoreMobileResize: true,
    normalizeScroll: true,
  });

  window.pd_smoother = smoother;
}

// Hamburger logic
if (document.querySelector(".navbar-collapse")) {
  select(".navbar-collapse").addEventListener("hide.bs.collapse", function () {
    select(".pd-menu-trigger").classList.remove("is-active");
    select("#site-header").classList.remove("mobile-menu-open");
  });
  select(".navbar-collapse").addEventListener("show.bs.collapse", function () {
    select(".pd-menu-trigger").classList.add("is-active");
    select("#site-header").classList.add("mobile-menu-open");
  });
}

// Collapse nav menu on link click
const navCollapse = new bootstrap.Collapse('.site-header .navbar-collapse', {toggle: false})
selectAll('#pd-menu-main_menu a').forEach(link => {
  link.addEventListener('click', () => {
    navCollapse.hide()
  })
})

// Use matchHeight for headers
function matchHeights() {
  const pdMain = document.querySelector("body #pd-main");
  const headerImg = document.querySelector(".pd-header-img");
  const wpadminbar = document.querySelector("#wpadminbar");
  const siteHeader = document.querySelector("#site-header");

  // Calculate the combined height of siteHeader and its paddingTop
  const siteHeaderHeight = siteHeader.offsetHeight;
  const siteHeaderPaddingTop = parseFloat(
    window.getComputedStyle(siteHeader).paddingTop
  );
  const totalHeaderHeight = siteHeaderHeight + siteHeaderPaddingTop;

  // Set the paddingTop for headerImg
  if (headerImg) {
    headerImg.style.paddingTop = totalHeaderHeight + "px";
  }

  // If the admin bar is present, adjust accordingly
  if (document.body.classList.contains("admin-bar") && wpadminbar) {
    document.querySelector(".site-header").style.marginTop =
      wpadminbar.offsetHeight + "px";
    pdMain.style.paddingTop = wpadminbar.offsetHeight + "px";
  }
}

// Recreate Headroom with ScrollTrigger
const siteHeader = document.querySelector(".site-header");
const wpadminbar = document.querySelector("#wpadminbar");
const preHead = document.querySelector("#pre-header");
const headerImg = document.querySelector(".pd-header-img");
const headerBarMobile = document.querySelector(".header-bar-mobile");
let preHeaderVisible = true;
let header_progress = 0;
let header_direction = 1;
let preHeaderHeight = preHead ? preHead.offsetHeight : 0; 
let preHeaderPaddingTop = preHead ? parseFloat(getComputedStyle(preHead).paddingTop) : 0; 
let preHeaderPaddingBottom = preHead ? parseFloat(getComputedStyle(preHead).paddingBottom) : 0; 
function hidePreHeader() {
  if (preHead && preHeaderVisible) {
    const headerBarHeight = headerBarMobile ? headerBarMobile.offsetHeight : 0;
    const tl = gsap.timeline();
    tl.to(preHead, { autoAlpha: 0, duration: 0.3, ease: 'power2.out' })
      .to(preHead, { 
        height: 0, 
        paddingTop: 0, 
        paddingBottom: 0, 
        duration: 0.25 
      }, ">-=0.25")
      .to(headerImg, { paddingTop: `${headerBarHeight}px` }, "<")
      .add(() => {
        preHead.classList.add("d-none");
      });

    preHeaderVisible = false;
  }
}

function showPreHeader() {
  if (preHead && !preHeaderVisible) {
    preHead.classList.remove("d-none");
    const tl = gsap.timeline();
    tl.to(preHead, { 
      height: preHeaderHeight, 
      paddingTop: preHeaderPaddingTop, 
      paddingBottom: preHeaderPaddingBottom, 
      duration: 0.25 
    })
    .to(preHead, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' }, ">-=0.25");
    preHeaderVisible = true;
  }
}

ScrollTrigger.create({
  trigger: "#pd-main",
  start: "+=100",
  end: "bottom bottom",
  onUpdate: function (self) {
    header_progress = self.progress.toFixed(2);
    header_direction = self.direction;

    if (header_progress == 0.0) {
      // Scroll is at the top
      siteHeader.classList.add("pd-top");
      siteHeader.classList.remove("pd-notTop");
      document.body.classList.remove("pd-is-scrolled");
      showPreHeader();
      if (wpadminbar && window.innerWidth <= 600) {
        siteHeader.style.marginTop = wpadminbar.offsetHeight + "px";
      }
    } else {
      // Page has been scrolled down
      siteHeader.classList.remove("pd-top");
      siteHeader.classList.add("pd-notTop");
      document.body.classList.add("pd-is-scrolled");
      hidePreHeader();
      if (wpadminbar && window.innerWidth <= 600) {
        siteHeader.style.marginTop = "0px";
      }
    }

    if (header_direction == -1) {
      // User is scrolling up
      siteHeader.classList.add('pd-pinned');
    } else {
      // User is scrolling down
      siteHeader.classList.remove('pd-pinned');

      // Close menu on scroll down - optional
      if (document.querySelector('.site-header').classList.contains('mobile-menu-open')) {
        document.querySelector('.pd-menu-trigger').click();
      }
    }
  },
});

// Add text animations for H1 block headings
document.querySelectorAll(".pd-heading-animation").forEach((block) => {
  let text = block.textContent;
  block.textContent = "";

  const maskContainer = document.createElement("div");
  maskContainer.style.overflow = "hidden";
  block.appendChild(maskContainer);

  // Split text into words, then wrap each word and a following space in a span
  text.split(" ").forEach((word) => {
    const span = document.createElement("span");
    span.style.display = "inline-block";
    span.innerHTML = `${word}&nbsp;`;

    maskContainer.appendChild(span);
  });

  // Animate spans with GSAP
  const spans = maskContainer.querySelectorAll("span");

  gsap.fromTo(
    spans,
    {
      opacity: 0,
      y: 30,
    },
    {
      scrollTrigger: {
        trigger: block,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.1,
      ease: "power2.out",
    }
  );
});

setupAnimationUtilities();

matchHeights();

// GSAP ScrollTo functionality
function scrollToTarget(target) {
  if (target) {
    // Check the window width and adjust the navOuterHeight accordingly
    const navOuterHeight = window.innerWidth <= 1200 ? 120 : 50;
    const yOffset =
      target.getBoundingClientRect().top + window.scrollY - navOuterHeight - 0;
    gsap.to(window, { scrollTo: yOffset, duration: 1, ease: "power2.inOut" });
  }
}

// Click event listener for anchor links using GSAP ScrollTo
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    if (this.getAttribute("href") !== "#") {
      const target = document.querySelector(this.getAttribute("href"));
      scrollToTarget(target);
    }
  });
});

// Handle links with slashes and GSAP ScrollTo
document.querySelectorAll('a[href^="/#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    if (this.getAttribute("href") !== "/#") {
      let selector = this.getAttribute("href").substring(1);
      let target = document.querySelector(selector);
      if (!!target) {
        e.preventDefault();
        scrollToTarget(target);
      }
    }
  });
});

// Ensure active state updates based on scroll position
document.querySelectorAll("section").forEach((section) => {
  ScrollTrigger.create({
    trigger: section,
    start: "top center",
    end: "bottom center",
    onEnter: () => setActiveNavItem(section.id),
    onEnterBack: () => setActiveNavItem(section.id),
  });
});

function setActiveNavItem(sectionId) {
  document
    .querySelectorAll("#site-header .nav-item .active")
    .forEach((item) => item.classList.remove("active"));
  const activeLink = document.querySelector(`a[href="#${sectionId}"]`);
  if (activeLink) {
    activeLink.classList.add("active");
  }
}

// Adds arrow functionality to nav pills
document.addEventListener('DOMContentLoaded', function () {
  var firstTab = new bootstrap.Tab(document.querySelector('.nav-link.active'));
  firstTab.show(); // Ensure the first tab is shown
});
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".nav-pills .nav-link");
  const chevronLeft = document.getElementById("chevron-left");
  const chevronRight = document.getElementById("chevron-right");

  chevronLeft.addEventListener("click", function () {
    const activeTab = document.querySelector(".nav-pills .nav-link.active");
    let previousTab = activeTab.parentElement.previousElementSibling;

    // Ensure we skip over the chevron icons
    while (previousTab && previousTab.querySelector(".nav-link") === null) {
      previousTab = previousTab.previousElementSibling;
    }

    if (previousTab) {
      previousTab.querySelector(".nav-link").click();
    } else {
      // If at the first tab, go to the last one
      tabs[tabs.length - 1].click();
    }
  });

  chevronRight.addEventListener("click", function () {
    const activeTab = document.querySelector(".nav-pills .nav-link.active");
    let nextTab = activeTab.parentElement.nextElementSibling;

    // Ensure we skip over the chevron icons
    while (nextTab && nextTab.querySelector(".nav-link") === null) {
      nextTab = nextTab.nextElementSibling;
    }

    if (nextTab) {
      nextTab.querySelector(".nav-link").click();
    } else {
      // If at the last tab, go to the first one
      tabs[0].click();
    }
  });
});

// ISI
if (document.querySelector("#isi-preview")) {
  const isiPreview = document.querySelector("#isi-preview");

  ScrollTrigger.create({
    trigger: "#isi-full",
    start: "top 90%",
    onEnter: () => {
      isiPreview.classList.add("hide");
    },
    onLeaveBack: () => {
      if (!isiPreview.classList.contains("closed")) {
        isiPreview.classList.remove("hide");
      }
    },
  });

  ScrollTrigger.create({
    trigger: "body",
    start: "top -100px",
    onEnter: () => {
      if (!isiPreview.classList.contains("closed")) {
        isiPreview.classList.remove("hide");
      }
    },
  });
}

if (document.querySelector(".intro-stagger")) {
  const introCards = document.querySelectorAll(".intro-stagger > div");
  gsap.from(introCards, {
    opacity: 0.001,
    y: 50,
    stagger: 0.2,
    duration: 0.75,
    delay: 0.25,
  });
}

// Set modal link dynamically
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("page-id-394")) {
    let externalLink = "";
    const modalElement = document.getElementById("external-link-modal");
    const modalInstance = new bootstrap.Modal(modalElement);
    document.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function (event) {
        let href = this.href;
        let isExternal = href.startsWith("http") && !href.includes(window.location.hostname);
        if (isExternal) {
          event.preventDefault();
          externalLink = href;
          modalInstance.show();
        }
      });
    });
    document.getElementById("externalLinkConfirm").addEventListener("click", function () {
      if (externalLink) {
        window.open(externalLink, "_blank");
      }
      modalInstance.hide();
    });
    modalElement.addEventListener("hidden.bs.modal", function () {
      externalLink = "";
    });
  }
});

// Event listeners and triggers
window.addEventListener("load", () => {
  // On load functions
});

// Resize with debounce - Let's debounce our heavy lifts
window.addEventListener(
  "resize",
  utils.debounce(() => {
    matchHeights();

    if (!utils.isTouchDevice()) {
      ScrollTrigger.refresh();
    }
  }, 250)
);

document.addEventListener("DOMContentLoaded", function () {
  let urlHash = window.location.href.split("#")[1];

  let scrollElem = document.querySelector("#" + urlHash);

  if (urlHash && scrollElem) {
    scrollToTarget(scrollElem);
  }
});